/* global Email */

/**
 * Send email
 */
const sendMailID = document.getElementById('sendMailID');

function sendMail() {
  const inputName = document.getElementById('inputName').value;
  const inputPhone = document.getElementById('inputPhone').value;
  const inputEmail = document.getElementById('inputEmail').value;
  const textArea = document.getElementById('textArea').value;
  Email.send({
    Host: 'smtp.elasticemail.com',
    Username: 'mds.lavoya@gmail.com',
    Password: 'abb1edfd-b873-4419-b612-99ca6a6e9931',
    To: 'paul.shih@fable.com.tw',
    From: 'mds.lavoya@gmail.com',
    Subject: 'Fable website question.',
    Body:
      `<h1>Get in touch!</h1><h2>Name: ${inputName}</h2><h2>Email: ${inputEmail}</h2><h2>Phone: ${inputPhone}</h2><h2>Content:</h2><p> ${textArea}</p>`,
  })
    .then(
      () => {
        alert('Thanks for reaching out. We’ll get back to you via email.'); // eslint-disable-line no-alert
      },
    );
}

sendMailID.addEventListener('click', sendMail);

/**
 * Send request for our latest insights.
 */
const sendRequestForSubscriptionID = document.getElementById('sendRequestForSubscriptionID');

function sendRequestForSubscription() {
  const subscribeInput = document.getElementById('subscribeInput').value;
  Email.send({
    Host: 'smtp.elasticemail.com',
    Username: 'mds.lavoya@gmail.com',
    Password: 'abb1edfd-b873-4419-b612-99ca6a6e9931',
    To: 'paul.shih@fable.com.tw',
    From: 'mds.lavoya@gmail.com',
    Subject: 'Fable website question.',
    Body:
      `<h1>Subscribe to Our latest insights!</h1><h3>Email: ${subscribeInput}</h3>`,
  })
    .then(
      () => {
        window.alert('Thanks for Subscription.'); // eslint-disable-line no-alert
      },
    );
}

sendRequestForSubscriptionID.addEventListener('click', sendRequestForSubscription);

/**
 * Send request for our latest insights with mobile phone.
 */

const sendRequestForSubscriptionByMobileID = document.getElementById('sendRequestForSubscriptionByMobileID');

function sendRequestForSubscriptionByMobile() {
  const subscribeInputMobile = document.getElementById('subscribeInputMobile').value;
  Email.send({
    Host: 'smtp.elasticemail.com',
    Username: 'mds.lavoya@gmail.com',
    Password: 'abb1edfd-b873-4419-b612-99ca6a6e9931',
    To: 'paul.shih@fable.com.tw',
    From: 'mds.lavoya@gmail.com',
    Subject: 'Fable website question.',
    Body:
      `<h1>Subscribe to Our latest insights!</h1><h3>Email: ${subscribeInputMobile}</h3>`,
  })
    .then(
      () => {
        window.alert('Thanks for Subscription.'); // eslint-disable-line no-alert
      },
    );
}

sendRequestForSubscriptionByMobileID.addEventListener('click', sendRequestForSubscriptionByMobile);
